<template>
  <div class="wt-toolbox-undoredo">
    <i
      class="wticon wticon-Redo2 -rotate-x"
      :class="{ disabled: !canUndo }"
      title="Undo"
      @click="clickUndo"
    />

    <i
      class="wticon wticon-Redo2"
      :class="{ disabled: !canRedo }"
      title="Redo"
      @click="clickRedo"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'wt-toolbox-undoredo',

  computed: {
    canUndo() {
      return this.timelineUndoRedo.isEnabled && this.timelineUndoRedo.canUndo;
    },

    canRedo() {
      return this.timelineUndoRedo.isEnabled && this.timelineUndoRedo.canRedo;
    },

    ...mapState({
      timelineUndoRedo: (state) => state.story.timelineUndoRedo,
    }),
  },

  methods: {
    clickUndo() {
      app.timelineGateway.undoredo.makeUndo();
    },

    clickRedo() {
      app.timelineGateway.undoredo.makeRedo();
    },
  },
});
</script>

<style lang="scss" scoped>
.wt-toolbox-undoredo {
  user-select: none;
  height: 16px;
  display: flex;

  i {
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    color: $color-normal;

    &.-rotate-x {
      transform: rotateY(180deg);
    }

    &:first-child {
      margin-right: 15px;
    }

    &:hover {
      color: $color-black;
    }

    &.disabled {
      color: $color-grey-2;
      pointer-events: none;
    }
  }
}
</style>
